import { useEffect } from 'react';

import { analyticsRuntime, type AnalyticsRuntime } from '../lib/analytics';
import { clearConsent, readConsent, type ConsentStorage, writeConsent } from '../lib/consent';
import {
  subscribeToCookiebotConsent,
  type CookiebotEventTarget,
} from '../lib/cookiebot-consent';
import { isNative } from '../lib/platform';

export interface AnalyticsConsentControllerProps {
  runtime?: Pick<AnalyticsRuntime, 'setStatisticsConsent'>;
  source?: CookiebotEventTarget;
  storage?: ConsentStorage | null;
  isNativePlatform?: boolean;
}

function browserStorage(): ConsentStorage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

/** Liga a fonte de consentimento da plataforma ao runtime de analytics, sem renderizar UI. */
export function AnalyticsConsentController({
  runtime = analyticsRuntime,
  source = window as CookiebotEventTarget,
  storage = browserStorage(),
  isNativePlatform = isNative(),
}: AnalyticsConsentControllerProps) {
  useEffect(() => {
    if (isNativePlatform) {
      void runtime.setStatisticsConsent(readConsent(storage).statistics);
      return undefined;
    }

    return subscribeToCookiebotConsent(source, (decision) => {
      if (decision.decided) writeConsent(decision.consent, storage);
      else clearConsent(storage);
      void runtime.setStatisticsConsent(decision.decided && decision.consent.statistics);
    });
  }, [isNativePlatform, runtime, source, storage]);

  return null;
}
